import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hide-btn-with-block-arrow", { active: _ctx.isShow }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickButton && _ctx.clickButton(...args)))
  }, [
    _createElementVNode("p", null, _toDisplayString(_ctx.isShow ? 'Свернуть' : 'Развернуть'), 1),
    _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
  ], 2))
}